import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, Params } from '@angular/router';

/**
 * Marque d'une route dont l'écran lit l'identifiant de son dossier UNE FOIS, à sa construction :
 * `data: { [UN_ECRAN_PAR_DOSSIER]: true }`.
 */
export const UN_ECRAN_PAR_DOSSIER = 'unEcranParDossier';

/**
 * Un dossier, un écran : passer de `/presidence/passations/A` à `/presidence/passations/B` RECRÉE la page
 * sur une route marquée {@link UN_ECRAN_PAR_DOSSIER}.
 *
 * <p>Par défaut, Angular RÉUTILISE le composant quand seule la valeur d'un paramètre change. Une page qui lit
 * son identifiant une fois (`route.snapshot.paramMap`) gardait donc le dossier A à l'écran sous l'adresse de B.
 * C'est ce que le CCE voyait en cliquant une notification depuis une page du même type : « le clic sur la
 * notification ne mène pas à la page dédiée » (retour du 2026-10-02, troisième fois).
 *
 * <p>Pourquoi une MARQUE et non la recréation partout : les pages « liste + dossier » (nominations CAC,
 * rapports du contrôleur…) suivent déjà leur paramètre et gardent leur liste, son défilement et ses filtres
 * en changeant de dossier — les recréer les ferait clignoter et perdre leur place. Une même adresse
 * (re-clic du menu, `onSameUrlNavigation: 'reload'`) réutilise toujours la page.
 */
export class UnEcranParDossierStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(futur: ActivatedRouteSnapshot, courant: ActivatedRouteSnapshot): boolean {
    if (!super.shouldReuseRoute(futur, courant)) {
      return false;
    }
    if (!futur.routeConfig?.data?.[UN_ECRAN_PAR_DOSSIER]) {
      return true;
    }
    return memesParametres(futur.params, courant.params);
  }
}

function memesParametres(a: Params, b: Params): boolean {
  const cles = new Set([...Object.keys(a), ...Object.keys(b)]);
  for (const k of cles) {
    if (a[k] !== b[k]) {
      return false;
    }
  }
  return true;
}
